import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const DebugUser = () => {
  const { user, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div style={{ padding: '2rem' }}>Loading...</div>;
  }

  return (
    <div style={{ padding: '2rem', fontFamily: 'monospace' }}>
      <h1>Debug: Current User State</h1>
      
      <button 
        onClick={() => navigate('/')}
        style={{
          padding: '0.5rem 1rem',
          marginBottom: '1rem',
          cursor: 'pointer'
        }}
      >
        ← Back to Home
      </button>

      <div style={{ 
        background: '#f5f5f5', 
        padding: '1rem', 
        borderRadius: '8px',
        marginTop: '1rem'
      }}>
        <h2>Authentication Status</h2>
        <p><strong>Is Authenticated:</strong> {isAuthenticated ? 'Yes' : 'No'}</p>
        <p><strong>Loading:</strong> {loading ? 'Yes' : 'No'}</p>
      </div>

      {user && (
        <div style={{ 
          background: '#f5f5f5', 
          padding: '1rem', 
          borderRadius: '8px',
          marginTop: '1rem'
        }}>
          <h2>User Object</h2>
          <pre style={{ 
            background: 'white', 
            padding: '1rem', 
            borderRadius: '4px',
            overflow: 'auto'
          }}>
            {JSON.stringify(user, null, 2)}
          </pre>
        </div>
      )}

      {!user && isAuthenticated && (
        <div style={{ 
          background: '#fff3cd', 
          padding: '1rem', 
          borderRadius: '8px',
          marginTop: '1rem'
        }}>
          <p>⚠️ Warning: Authenticated but user object is null</p>
        </div>
      )}

      {!isAuthenticated && (
        <div style={{ 
          background: '#f8d7da', 
          padding: '1rem', 
          borderRadius: '8px',
          marginTop: '1rem'
        }}>
          <p>Not authenticated. Please login first.</p>
        </div>
      )}

      <div style={{ 
        background: '#d1ecf1', 
        padding: '1rem', 
        borderRadius: '8px',
        marginTop: '1rem'
      }}>
        <h3>Admin Access Check</h3>
        <p><strong>User Role:</strong> {user?.role || 'Not set'}</p>
        <p><strong>Can Access Admin:</strong> {user?.role === 'admin' ? '✅ Yes' : '❌ No'}</p>
        
        {user?.role === 'admin' && (
          <button 
            onClick={() => navigate('/admin')}
            style={{
              padding: '0.75rem 1.5rem',
              marginTop: '1rem',
              background: '#4ade80',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Go to Admin Panel
          </button>
        )}
      </div>
    </div>
  );
};

export default DebugUser;
